import { render, staticRenderFns } from "./study.vue?vue&type=template&id=1fd199cc&scoped=true&"
import script from "./study.vue?vue&type=script&lang=js&"
export * from "./study.vue?vue&type=script&lang=js&"
import style0 from "./study.vue?vue&type=style&index=0&id=1fd199cc&prod&lang=css&"
import style1 from "./study.vue?vue&type=style&index=1&id=1fd199cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd199cc",
  null
  
)

export default component.exports